import { isNativeAudioNode } from '../guards/native-audio-node';
export var interceptConnections = function interceptConnections(original, interceptor) {
  original.connect = function (destination) // tslint:disable-line:no-inferrable-types
  {
    var output = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var input = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    if (isNativeAudioNode(destination)) {
      // @todo TypeScript cannot infer the overloaded signature with 3 arguments yet.
      interceptor.connect.call(interceptor, destination, output, input); // Bug #11: Safari does not support chaining yet.

      return destination;
    } // @todo TypeScript does still assume that connect() returns void.


    return interceptor.connect.call(interceptor, destination, output);
  };

  original.disconnect = function () {
    // @todo TypeScript cannot infer all the signatures yet.
    interceptor.disconnect.apply(interceptor, arguments);
  };

  return original;
};